import React, { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { db } from '@root/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { deleteFile } from '@utils/FilesFolders';
import { toast } from 'react-hot-toast';
import TributeCard from '@components/TributeCard';

function MyMemorial({ setTributeCount }) {
  const { globalUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [tributes, setTributes] = useState([]);

  useEffect(() => {
    const fetchUserTributes = async () => {
      try {
        if (!globalUser?.uid) return;

        const memorialsQuery = query(
          collection(db, 'memorials'),
          where('uid', '==', globalUser.uid.trim())
        );
        const memorialsSnapshot = await getDocs(memorialsQuery);

        const userTributes = memorialsSnapshot.docs.map((docSnapshot) => ({
          ...docSnapshot.data(),
          tributeId: docSnapshot.id,
        }));

        setTributes(userTributes);
        setTributeCount(userTributes.length);
      } catch (error) {
        console.error('Error fetching user tributes:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserTributes();
  }, [globalUser?.uid, setTributeCount]);

  if (loading) return <p>Loading...</p>;

  const handleDeleteTribute = async (sanitizedId) => {
    try {
      // Delete the tribute from Firestore and associated files
      await deleteFile(`memorials/${sanitizedId}`);
      await deleteFile(`memorialsFav/${sanitizedId}`);
      await deleteFile(`memorialsLike/${sanitizedId}`);

      // Remove from UI
      setTributes((prev) =>
        prev.filter((t) => t.tributeId.split('/')[0] !== sanitizedId)
      );
      setTributeCount((prev) => Math.max(0, prev - 1));
      toast.success('Tribute Deleted');
    } catch (error) {
      console.error('Failed to delete file and document:', error);
      toast.error('Tribute Deletion Error');
    }
  };

  const handleEditTribute = (sanitizedId) => {
    // TODO: route or open modal for editing
    console.log('Edit tribute:', sanitizedId);
  };

  return (
    <>
      {tributes.length > 0 ? (
        <div className='col-9'>
          <div className='col-lg-12'>
            <div className='card'>
              <div className='card-body'>
                <div className='input-group'>
                  <input
                    type='text'
                    className='form-control'
                    id='txtMemorialSearch'
                    placeholder='Search All Memorials'
                  />
                  <button
                    className='btn btn-primary btn-xs'
                    id='btnMemorialSearch'
                    type='button'
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className='row g-3'>
            {tributes.map((t) => (
              <div
                className='col-xl-4 col-xxl-4 col-lg-4 col-md-6 col-sm-6 items'
                key={t.tributeId}
              >
                <TributeCard
                  tribute={t}
                  currentUid={globalUser?.uid}
                  ownerUid={t.uid}
                />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className='col-xl-9'>
          <div className='card overflow-hidden'>
            <div className='card-header'>
              <h4 className='card-title'>My Memorials</h4>
              <p className='card-title-desc'>You have no memorials to show</p>
            </div>
            <div className='card-body bg-warning' />
          </div>
        </div>
      )}
      ;
    </>
  );
}

export default MyMemorial;
